export default __webpack_public_path__ + "assets/8447b84c5e587e2f9d2617c400117f33.webp";